import React from "react";
import style from "./ModuleEncartMt.scss";
import { Link } from "react-router-dom";
import * as icones from "../Icones";
import * as tools from "../Tools";
import isExternal from "is-url-external";
import * as api from "../api.js";

const Fleche = ({ color }) =>
  color == "rouge" ? <icones.fleche /> : <icones.flecheRouge />;

export class ModuleEncartMt extends React.Component {
  icone(nomIcone) {
    return (
      <img
        src={nomIcone}
        style={{
          width: "120px",
          position: "absolute",
          zIndex: "2",
          top: "50%",
          left: "50%" /* à 50%/50% du parent référent */,
          transform:
            "translate(-50%, -50%)" /* décalage de 50% de sa propre taille */
        }}
      />
    );
  }

  // checkFleche(color) {
  // 	if (color == 'rouge') {
  // 		return <icones.flecheRouge />
  // 	} else {
  // 		return <icones.fleche />
  // 	}
  // }

  content() {
    const { element } = this.props;
    return (
      <div className={style.moduleEncart, !element.hoverHidden ? style.moduleEncartHover:""} style={{ borderRadius: "10px" }}>
        <div
          className={style.moduleEncartMtTitre}
          style={{
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            // borderBottomLeftRadius: "10px",
            // borderBottomRightRadius: "10px",
            borderBottomLeftRadius: element.margeBasHidden ? "10px" : "0px",
            borderBottomRightRadius: element.margeBasHidden ? "10px" : "0px",
            backgroundColor: element.couleurTitre || "#7cb4d7"
          }}
        >
          {/* *** titre *** */}
          <h4
            className="text-center pt-2 ft-lato text-white"
            style={{ fontSize: "1.2rem" }}
          >
            {element.titre}
          </h4>
          {/* ******************** */}

          {/* *** image *** */}
          <div
            // className={" " + style.encartContenuImage}
            style={{ position: "relative" }}
          >
            <div className="align-self-center" style={{ margin: "0 auto" }}>
              {this.icone(element.iconSrc)}
            </div>
            <div
              className={" " + style.encartFleche}
              style={{
                zIndex: "5",
                position: "absolute",
                marginTop: "-1px",
                borderTop: "15px solid " + element.couleurTitre || "#7cb4d7"
              }}
            />
            <img
              src={`${tools.lienPhotos}/${element.imgSrc}`}
              className={"img-fluid"}
              style={{
                filter: "brightness(" + element.brightness || 70 + "%)",
                zIndex: "1",
                borderBottomLeftRadius: element.margeBasHidden ? "10px" : "0px",
                borderBottomRightRadius: element.margeBasHidden ? "10px" : "0px"
              }}
            />
          </div>
        </div>
        {/* ********************** */}
        {!element.margeBasHidden && (
          <React.Fragment>
            <div
              style={{
                border: "0px solid #fff",
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                backgroundColor: "#fff"
              }}
            >
              <div style={{ zIndex: "10" }}>
                <h5
                  className="pl-4 pr-4 pt-4 ft-alegreya-sans-medium"
                  style={{ color: "#333" }}
                >
                  {element.sousTitre}
                </h5>
                <div className="pl-4 pr-4 text-justify">
                  <div
                    className="ft-alegreya-sans-light pb-3 text-black"
                    dangerouslySetInnerHTML={{ __html: element.contenu }}
                  />

                  {/* Bloc Lire la suite */}
                  {!element.lireLaSuiteHidden && (
                    <div
                      className="ml-1 ft-lato-light pb-4"
                      style={{ color: "#333", fontSize: "1.2em" }}
                    >
                      <icones.flecheCouleur
                        width={25}
                        couleur={element.couleurTitre}
                      />
                      &nbsp;&nbsp;{element.textLink || "Lire la suite"}
                    </div>
                  )}
                  {element.lireLaSuiteHidden && <p className="pb-2"></p>}
                  {/* ********************************** */}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  render() {
    const { element } = this.props;
    return (
      <React.Fragment>
        <div className={"col-xl-4 col-md-6 mb-5 block"}>
          {/* {element.nonNonCliquable ? } */}

          {!element.nonCliquable ? (
            <React.Fragment>
              {api.authentification.locked(element.roles) ? (
                <span style={{ cursor: "not-allowed" }}>{this.content()}</span>
              ) : (
                <React.Fragment>
                  {isExternal(element.linkTo) ? (
                    <a
                      href={element.linkTo}
                      target="_blank"
                      to={element.linkTo}
                      style={{ textDecoration: "none" }}
                    >
                      {this.content()}
                    </a>
                  ) : (
                    <Link
                      to={element.linkTo}
                      className=""
                      style={{ textDecoration: "none" }}
                    >
                      {this.content()}
                    </Link>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            this.content()
          )}
        </div>
      </React.Fragment>
    );
  }
}
